window.MinorSchedulingAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['MinorSchedulingServers']);

    self.getBrandSchoolTemplates = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request("brands/" + brandId + "/school_templates", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.getBrandSchoolTemplatesSettings = (brandId, options = null) => {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        let params = {};

        if (options) {
            const {
                fields = [],
                limit,
                offset,
                status
            } = options;

            if (fields.length > 0) {
                params.fields = fields.join(',');
            }
            if (limit) {
                params.limit = limit;
            }
            if (offset !== undefined) {
                params.offset = offset;
            }
            if (status) {
                params.status = status;
            }
        }

        _protected.request(`brands/${brandId}/settings/school_templates`, "GET", params)
            .then((res) => {
                if (res?.data?.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandMinorWorkRulesSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request("brands/" + brandId + "/settings/minor_work_rules", "GET")
            .then(function (res) {
                if (res.data && res.data.data  && res.status == 200) {
                    deferred.resolve(res.data.data.brand_minor_work_rules || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.archiveSchoolTemplate = (brandId, schoolTemplateId) => {

        if (!brandId) {
            throw "No brand id";
        }

        if (!schoolTemplateId) {
            throw "No school template id";
        }

        var deferred = $q.defer();

        _protected.request(`brands/${brandId}/settings/school_templates/${schoolTemplateId}`, "DELETE")
            .then(function (res) {
                    if (res && res.data && res.data.data && res.status === 200) {
                        deferred.resolve(res.data.data);

                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteMinorWorkRule = function (ruleId, brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/minor_work_rules/" + ruleId, "DELETE")
            .then(function (res) {
                    if (res && res.data && res.data.data && res.status === 200) {
                        deferred.resolve(res.data.data);

                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.addNewBrandSchoolTemplate = function (brandId, data) {
        var deferred = $q.defer();
        var payLoad = {brand_school_template : data};

        _protected.request("brands/" + brandId + "/settings/school_templates", "POST", payLoad)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };

    self.addNewMinorWorkRule = function (brandId, data) {
        var deferred = $q.defer();
        var payLoad = {minor_work_rule : data};

        _protected.request("brands/" + brandId + "/settings/minor_work_rules", "POST", payLoad)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };

    self.updateSchoolTemplate = function (brandId,data) {
        var defer = $q.defer();
        var payLoad = {brand_school_template : data};
        _protected.request('brands/' + brandId + "/settings/school_templates/" + data.id, "PUT", payLoad)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateMinorWorkRule = function (brandId,data) {
        var defer = $q.defer();
        var payLoad = {minor_work_rule : data};
        _protected.request('brands/' + brandId + "/settings/minor_work_rules" , "PUT", payLoad)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUserSchoolTemplates = function (brandId, userId) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No User id";
        }

        var defer = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/school_templates', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.addNewUserSchoolTemplate = function (brandId, userId, schoolTemplateDate, isFromPP) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No User id";
        }

        var defer = $q.defer();

        var url = 'brands/' + brandId + '/users/' + userId + '/school_templates';
        if (isFromPP) {
            url = self.apiUrl.replace('v1', 'v2') + url;
        }

        _protected.request(url, 'POST', schoolTemplateDate)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.editUserSchoolTemplate = function (brandId, userId, schoolTemplateId ,schoolTemplateDate, isFromPP) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No User id";
        }

        if (!schoolTemplateId) {
            throw "No School Template id";
        }

        var defer = $q.defer();

        var url = 'brands/' + brandId + '/users/' + userId + '/school_templates/' + schoolTemplateId;
        if (isFromPP) {
            url = self.apiUrl.replace('v1', 'v2') + url;
        }

        _protected.request(url, 'PUT', schoolTemplateDate)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getMinorWorkRules = function (brandId, day) {
        var deferred = $q.defer();
        var params = {
            'day': day
        };

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request("brands/" + brandId + "/minor_work_rules", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.brand_minor_work_rules || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.deleteUserSchoolTemplate = function (brandId, userId, schoolTemplateId, isFromPP) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No User id";
        }

        if (!schoolTemplateId) {
            throw "No School Template id";
        }

        var defer = $q.defer();

        var url = 'brands/' + brandId + '/users/' + userId + '/school_templates/' + schoolTemplateId;
        if (isFromPP) {
            url = self.apiUrl.replace('v1', 'v2') + url;
        }

        _protected.request(url, 'DELETE')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUsersSchoolsCalenders = function (brandId, week) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            week: week
        };

        _protected.request('brands/' + brandId + '/users/school_templates/periods', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandMinorRules = function (brandId, week) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            week: week
        };

        _protected.request('brands/' + brandId + '/minor_work_rules', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandMinorTypes = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/minor_types', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.minor_types || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandMinorCategories = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/minor_type_categories', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.brand_minor_type_categories || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUsersSchoolTemplates = function (brandId, params) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/minor_school_template', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getSchoolTemplatesUsersLocations = function (brandId, schoolTemplateId, params) {
        let defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }
        if (!schoolTemplateId) {
            throw "No school template id";
        }

        _protected.request(`brands/${brandId}/school_templates/${schoolTemplateId}/users`, 'GET', params)
            .then(function (res) {
                if (res.data?.data && res.status === 200) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getMinorWorkPermitRestrictedAges = async (brandId) => {
        if (!brandId) {
            throw new Error("No brand id");
        }
        try {
            const res = await _protected.request(`brands/${brandId}/settings/minor_work_permit`, 'GET');
            if (res?.data?.data && res.status === 200) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.addMinorWorkPermitRestrictedAges = async (brandId, restrictedAges) => {
        let payload = {
            restricted_ages: restrictedAges
        }
        if (!brandId) {
            throw new Error("No brand id");
        }
        try {
            const res = await _protected.request(`brands/${brandId}/settings/minor_work_permit`, 'PUT', payload);
            if (res?.data?.data && res.status === 200) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };
    self.getMinorWorkPermitSettings = async (brandId) => {
        if (!brandId) {
            throw new Error("No brand id");
        }
        try {
            const res = await _protected.request(`brands/${brandId}/minor_work_permit/settings`, 'GET');
            if (res?.data?.data && res.status === 200) {
                return res.data.data.minor_work_permit || {};
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.getMinorUsersWorkPermit = async (brandId) => {
        if (!brandId) {
            throw new Error("No brand id");
        }
        try {
            const res = await _protected.request(`brands/${brandId}/users/minor_work_permits`, 'GET');
            if (res?.data?.data && res.status === 200) {
                return res.data.data.users || [];
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.validateSchoolTemplates = async function (brandId, payLoad) {
        const response = await _protected.request(`brands/${brandId}/templates/school_templates/validate`, "POST", payLoad);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.applySchoolTemplates = async function (brandId, payLoad) {
        const response = await _protected.request(`brands/${brandId}/templates/school_templates/apply`, "POST", payLoad);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.unarchiveSchoolTemplate = async (brandId, schoolTemplateId) => {
        const response = await _protected.request(`brands/${brandId}/settings/school_templates/${schoolTemplateId}/recover`, "POST");
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }
        throw response;
    };

});
